import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './home.css';
// import AOS from 'aos';
import 'aos/dist/aos.css';
import banner2 from '../../images/home_images/banner_2.jpg'
import banner3 from '../../images/home_images/banner3.jpeg'
import banner4 from '../../images/home_images/banner4.jpeg'
import '../../styles/consultancy.css'
import { NavLink } from 'react-router-dom';
import Offering from 'pages/Home/components/Offering';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import ad from '../images/workshop_images/workshop-poster.jpg'

function Home() {
  const [loading, setLoading] = useState(true);
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  // const [showPopup, setShowPopup] = useState(false);

  // useEffect(() => {
  //   // Show popup 5 seconds after the website loads
  //   const timer = setTimeout(() => {
  //     setShowPopup(true);
  //   }, 5000);

  //   // Cleanup the timer on unmount
  //   return () => clearTimeout(timer);
  // }, []);

  // // Close the popup
  // const closePopup = () => {
  //   setShowPopup(false);
  // };


  // useEffect(() => {
  //   const alreadySelected = sessionStorage.getItem('languageSelected');
  // 
  //   if (!alreadySelected) {
  //     const timer = setTimeout(() => {
  //       setIsLanguageModalOpen(true);
  //     }, 7000);
  // 
  //     return () => clearTimeout(timer);
  //   }
  // }, []);
  

  const closePopup = () => {
    sessionStorage.setItem('languageSelected', 'true'); // Mark as dismissed for this session
    setIsLanguageModalOpen(false);
  };
    




  const changeLanguage = (lang) => {
    console.log(`🔄 Attempting to change language to: ${lang}`);
    document.cookie = `googtrans=/auto/${lang}; path=/`;
  
    // ✅ Store in sessionStorage instead of localStorage
    sessionStorage.setItem('languageSelected', 'true');
  
    window.location.reload(); // Reload to apply translation
  };
  


  const points = [
    {
      text: "Rooted in Naturopathy & Jain principles",
      icon: "/images/naturopathy.png",
    },
    {
      text: "Expert-driven & Science-backed",
      icon: "/images/science.png",
    },
    {
      text: "Powered by Data, AI & Analytics",
      icon: "/images/ai.png",
    },
    {
      text: "Empowering, not just guiding your journey",
      icon: "/images/journey.png",
    },
    {
      text: "Advocating Sustainability & Eco-friendly choices",
      icon: "/images/landscape.png",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3 // Delays between each child animation
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };


  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      AOS.init({ duration: 1500, easing: 'ease-in-out' });

      setLoading(false); // Set loading to false after content is loaded
    }, 1500); // Adjust time as needed

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, []);



  return (
    <>
      {/* Loader */}
      {loading && <div className="loader-container">
        <div className="loader"></div>
        <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
      </div>}


      {!loading && (
        <>
          {/* {showPopup && (
            <div className="popup-overlay">
              <div className="popup-content">
                <button className="close-popup" onClick={closePopup}>
                  &times;
                </button>
                <NavLink to="/workshopdetails" onClick={() => {
                  window.scrollTo(0, 0);
                }}>
                <img
                  src={ad} // Replace with your image path
                  alt="Popup"
                  className="popup-image"
                />
                </NavLink>
              </div>
            </div>
          )} */}

          <div className=''>
            {/* {isLanguageModalOpen && (
              <div className="select-language popup-overlay">
                <div className="popup-content bg-white p-3">
                  <button className="language close-popup" onClick={closePopup}>
                    &times;
                  </button>
                  <h5 className='fw-bold' translate='no'>वेबसाइट की भाषा चुनें / Select website language</h5>
                  <div className="button-container d-flex items-center justify-content-center gap-4 mt-5">
                    <button className='btn' onClick={() => changeLanguage('hi')}>हिंदी</button>
                    <button className='btn' onClick={() => changeLanguage('en')}>English</button>
                  </div>
                </div>
              </div>
            )} */}
          </div>

          <section className="banner-section ">
            <Swiper
              modules={[Navigation, Pagination, Autoplay, EffectFade]}
              navigation={true}
              pagination={{ clickable: true }}
              loop={true}
              autoplay={{ delay: 2000, }}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              speed={8000}
              className="swiper-container"
              style={{ height: '100vh' }}
            >

              <SwiperSlide>
                <img src={banner2} alt="Banner 4" className="carousel-image" style={{ borderRadius: '0px' }} />
                <div className="banner-text">
                  <h1>"IT IS OUR CHOICES THAT SHOW WHAT WE <br /> TRULY ARE, FAR MORE THAN OUR ABILITIES"</h1>
                  <div className="banner-button">
                    <div className="how">
                      <NavLink
                        to="/contact"
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >

                        <button type="button" className="btn">Book Free Consultancy</button>

                      </NavLink>
                    </div>
                    <NavLink
                      to="/contact"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <button type="button" className="btn">Contact Us</button>
                    </NavLink>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <img src={banner3} alt="Banner 2" className="carousel-image" style={{ borderRadius: '0px' }} />
                <div className="banner-text">
                  <h1 translate="no">"उदय के समय नहीं, बंध के समय चेतो"</h1>
                  <div className="banner-button">
                    <div className="how">
                      <NavLink
                        to="/contact"
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        <button type="button" className="btn">Book Free Consultancy</button>
                      </NavLink>
                    </div>
                    <NavLink
                      to="/contact"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >

                      <button type="button" className="btn">Contact Us</button>

                    </NavLink>
                  </div>


                </div>
              </SwiperSlide>
              <SwiperSlide>
                <img src={banner4} alt="Banner 3" className="carousel-image" style={{ borderRadius: '0px' }} />
                <div className="banner-text">
                  <h1>"ALL WE HAVE TO DECIDE IS WHAT TO DO <br /> WITH THE TIME THAT IS GIVEN TO US"</h1>
                  <div className="banner-button">
                    <div className="how">
                      <NavLink
                        to="/contact"
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        <button type="button" className="btn">Book Free Consultancy</button>
                      </NavLink>
                    </div>
                    <NavLink
                      to="/contact"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <button type="button" className="btn">Contact Us</button>
                    </NavLink>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </section>





          <section className='intro-section'>
            <div className="container">
              <div className="work-text" >
                <h3
                  className='fonts text-center text-dark mb-4 fw-bold offering-title'
                  style={{ maxWidth: '820px', margin: '0 auto' }}
                >Our mission is to
                  <strong style={{ color: '#9D3B24' }}> elevate your holistic health and well-being</strong> by empowering your journey toward

                  <strong style={{ color: '#9D3B24' }}> a natural, healthy lifestyle.</strong>
                </h3>
                <div className="living-text row">
                  <h4 className="fw-bold text-center">
                    <strong style={{ color: '#9D3B24' }}>Why a natural, healthy lifestyle?</strong>
                  </h4>
                  <div className="row d-flex justify-content-center mb-5 mt-5">
                    <div className="col-md-5 living-det">
                      <h4 className="fw-bold"><strong>The Problem</strong></h4>
                      <p className="mt-3" data-aos="zoom-in" data-aos-duration="2000" style={{ textAlign: 'justify' }}>
                        <strong style={{ color: '#9D3B24' }}>Lifestyle Chronic diseases</strong> like diabetes, heart disease, and cancer cause <strong style={{ color: '#9D3B24' }}>70% of global deaths</strong>, with <strong style={{ color: '#9D3B24' }}>1 in 4 Indians at risk</strong> of early death due to poor lifestyle choices. <strong style={{ color: '#9D3B24' }}>Climate change</strong> worsens the crisis, threatening <strong style={{ color: '#9D3B24' }}>250,000 lives every year</strong> from 2030 to 2050.
                      </p>
                    </div>
                    <div className="col-md-5 living-det">
                      <h4 className="fw-bold"><strong>The Solution</strong></h4>
                      <p className="mt-3" data-aos="zoom-in" data-aos-duration="2000" style={{ textAlign: 'justify' }}>
                        Studies show <strong style={{ color: '#9D3B24' }}>65% of chronic disease patients improve with natural therapies</strong> like yoga, herbal remedies, and mindful eating—offering holistic healing, avoiding dependency and side effects of modern medicine, while reducing our ecological footprint.
                      </p>
                    </div>
                  </div>

                  <div className="row d-flex justify-content-center">
                    <div className="col-md-6 living-det text-center">
                      <h4 className="fw-bold"><strong>The Call to Action</strong></h4>
                      <p className="mt-3" data-aos="zoom-in" data-aos-duration="2000" style={{ textAlign: 'justify' }}>
                        Inspired by Jain Agamas—'उदय के समय नहीं, बंध के समय चेतो' ('Be alert from the onset, not just when it matures')—<strong style={{ color: '#9D3B24' }}>Anuyog champions the early adoption of healthy lifestyles.</strong> Combining ancient wisdom, science, and technology, we make natural living simple, transformative, and accessible, empowering you to achieve holistic wellness and harmony with the planet <strong style={{ color: '#9D3B24' }}> Act now—before illness or environmental damage takes hold.</strong>
                        <h3 className='text-center mt-2'><strong style={{ color: '#9D3B24' }}>Start today with Anuyog!
                        </strong></h3>
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <section className="why-anuyog-section">
            <div className="container">
              <h1 className="section-title mb-3" data-aos="fade-down" data-aos-duration="3000">Why Anuyog?</h1>
              <h4 className='fw-bold mb-5 offering-title'>Discover why Anuyog is the trusted partner for your transformative wellness journey.</h4>
              <motion.div
                className="why-anuyog-list"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                style={{ marginTop: "20px" }}
              >
                {points.map((point, index) => (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    className="why-anuyog-point"
                  >
                    <img
                      src={point.icon}
                      alt={`Icon for ${point.text}`}
                      style={{
                        width: '60px',
                        height: '60px',
                        marginBottom: '10px',
                        filter: 'brightness(100%)',
                      }}
                    />

                    {point.text}
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </section>

          <Offering />
        </>
      )}
    </>
  );
}

export default Home;